import { render, staticRenderFns } from "./FreelancerWorkIcon.vue?vue&type=template&id=12047d60"
import script from "./FreelancerWorkIcon.vue?vue&type=script&lang=js"
export * from "./FreelancerWorkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports